/**
 * Lenient bold for marked: allows `test** bold**` (non-left-flanking `**`).
 * Italic `_` is left to marked's built-in handling so underscores inside words
 * stay literal (e.g. @age_min, snake_case).
 */
export function lenientEmphasis() {
  return {
    extensions: [
      {
        name: "lenientBold",
        level: "inline",
        start(src) {
          return src.indexOf("**");
        },
        tokenizer(src) {
          const match = src.match(/^\*\*(.+?)\*\*/);
          if (match) {
            return {
              type: "lenientBold",
              raw: match[0],
              text: match[1],
              tokens: this.lexer.inlineTokens(match[1]),
            };
          }
          return undefined;
        },
        renderer(token) {
          return `<strong>${this.parser.parseInline(token.tokens)}</strong>`;
        },
      },
    ],
  };
}
